module.exports = __webpack_public_path__ + "img/736.b432ff5d.jpg";